var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Stack, Customizer, mergeStyles, getTheme } from 'office-ui-fabric-react';
import { TodoFooter } from './TodoFooter';
import { TodoHeader } from './TodoHeader';
import { TodoList } from './TodoList';
// TODO: Change me to another theme!
import { TeamsCustomizations } from '@uifabric/theme-samples';
var index = 0;
// TODO: Change this to add other CSS styles like backgroundColor, fontSize, etc
var className = mergeStyles(__assign({ padding: 25 }, getTheme().effects.elevation4));
var TodoApp = /** @class */ (function (_super) {
    __extends(TodoApp, _super);
    function TodoApp(props) {
        var _this = _super.call(this, props) || this;
        _this._addTodo = function (label) {
            var _a;
            var todos = _this.state.todos;
            var id = index++;
            _this.setState({
                todos: __assign({}, todos, (_a = {}, _a[id] = { label: label }, _a))
            });
        };
        _this._remove = function (id) {
            var newTodos = __assign({}, _this.state.todos);
            delete newTodos[id];
            _this.setState({
                todos: newTodos
            });
        };
        _this._complete = function (id) {
            var newTodos = __assign({}, _this.state.todos);
            newTodos[id].completed = !newTodos[id].completed;
            _this.setState({
                todos: newTodos
            });
        };
        _this._edit = function (id, label) {
            var newTodos = __assign({}, _this.state.todos);
            newTodos[id] = __assign({}, newTodos[id], { label: label });
            _this.setState({
                todos: newTodos
            });
        };
        _this._clear = function () {
            var todos = _this.state.todos;
            var newTodos = {};
            Object.keys(_this.state.todos).forEach(function (id) {
                if (!todos[id].completed) {
                    newTodos[id] = todos[id];
                }
            });
            _this.setState({
                todos: newTodos
            });
        };
        _this._setFilter = function (filter) {
            _this.setState({
                filter: filter
            });
        };
        _this.state = {
            todos: {},
            filter: 'all'
        };
        return _this;
    }
    TodoApp.prototype.render = function () {
        var _a = this.state, filter = _a.filter, todos = _a.todos;
        return (React.createElement(Customizer, __assign({}, TeamsCustomizations),
            React.createElement(Stack, { horizontalAlign: "center" },
                React.createElement(Stack, { style: { width: 400 }, gap: 25, className: className },
                    React.createElement(TodoHeader, { addTodo: this._addTodo, setFilter: this._setFilter, filter: filter }),
                    React.createElement(TodoList, { complete: this._complete, todos: todos, filter: filter, remove: this._remove, edit: this._edit }),
                    React.createElement(TodoFooter, { clear: this._clear, todos: todos })))));
    };
    return TodoApp;
}(React.Component));
export { TodoApp };
